import React from "react";
import ChipText from "../../connectui/component/display/chip/ChipText";
import ChipIcon from "../../connectui/component/display/chip/ChipIcon";
import ChipIconText from "../../connectui/component/display/chip/ChipIconText";
import OutlinedChipBase from "../../connectui/component/display/chip/base/OutlinedChipBase";
import PersonIcon from "@material-ui/icons/Person";
import ChipRow from "../../connectui/component/display/chip/ChipRow";

const ChipRowExample = () => {
  const chips = [
    {
      Component: ChipText,
      text: "Basic Chip",
      sx: {backgroundColor: "#D4E157", color: "#000"},
    },
    {
      Component: ChipIcon,
      icon: <PersonIcon />,
      sx: {backgroundColor: "#FFCDD2"},
    },
    {
      Component: ChipIconText,
      text: "With Icon",
      icon: <PersonIcon />,
      sx: {backgroundColor: "#BBDEFB", color: "#0D47A1"},
    },
    {
      Component: ChipText,
      text: "Outlined Chip",
      chipBase: OutlinedChipBase,
      sx: {color: "#1976D2", borderColor: "#1976D2"},
    },
    {
      Component: ChipIconText,
      text: "Outlined Chip With Icon",
      icon: <PersonIcon />,
      chipBase: OutlinedChipBase,
    },
  ];

  return (
    <div>
      <h3>ChipRow Example</h3>
      <ChipRow chips={chips} gap="12px" />
    </div>
  );
};

export default ChipRowExample;
